import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=209c9121"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports